import discount from '@/api/promotion/discount'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
    ...baseState
}

export const getters = {

}

export const mutations = {
    ...baseMutations
}

export const actions = {
  store(context, data) {
    return discount.store(data)
  },
  update(context, { id, data }) {
    return discount.update(id, data)
  },
  find(context, id) {
    return discount.find(id)
  }
}